import {
  CreateOperatingCostRequest,
  FilterOperatingCostRequest,
  OperatingCostModel,
} from "../../../infrastructure/model/OperatingCostModel";
import OperatingCostService from "../../../infrastructure/services/OperatingCostService";
import HttpUtils from "../../utils/HttpUtils";
import { BaseCommonApiUseCaseDeps } from "./CommonApiUseCase";

export const getOperatingCostUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    request: FilterOperatingCostRequest;
  },
): Promise<OperatingCostModel[]> => {
  const { setLoading, showError, request } = deps;
  try {
    setLoading?.(true);
    let dataMapper: OperatingCostModel[] = [];
    const res = await OperatingCostService.getListOperatingCost(request);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const createOperatingCostUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    request: CreateOperatingCostRequest;
  },
): Promise<OperatingCostModel | undefined> => {
  const { request, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: OperatingCostModel | undefined = undefined;
    const res = await OperatingCostService.createOperatingCost(request);

    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        showSuccess?.();
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const deleteOperatingCostUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { id: number },
): Promise<boolean> => {
  const { id, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper = false;
    const res = await OperatingCostService.deleteOperatingCost(id);

    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccess() {
        showSuccess?.();
        dataMapper = true;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};
